import { FC } from 'react'

import styled from 'styled-components'

import { CustomScrollbarWrapper } from 'src/Components/CustomScrollbarWrapper'
import { SpotifyTrack } from 'src/Redux/spotifyTracksApi'
import { device } from 'src/Styled/variables'
import { TrackAudioPlayer } from 'src/Components/TrackAudioPlayer'
import { onPlaySearchedTrack } from 'src/Helpers/TagManager/TrackEvent'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'

import { WidgetListLoading } from '../WidgetListLoading'
import { WidgetListError } from '../WidgetListError'

import { SpotifyWidgetListItem } from './SpotifyWidgetListItem'

interface SpotifyWidgetListProps {
  loading?: boolean
  error?: string
  tracks?: SpotifyTrack[]
}

const WrapperList = styled(CustomScrollbarWrapper)<{ fitContent: boolean }>`
  height: ${({ fitContent }) => (fitContent ? 'fit-content' : '400px')};
`
const Wrapper = styled.div`
  border-radius: 8px;
  background: ${({ theme }) => theme.color.white};
  padding: 4px 4px 0 4px;
  @media ${device.mobileMax} {
    margin-bottom: 50px;
  }
`
const LoadingWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 400px;
  overflow: hidden;
`
const MIN_TRACKS_COUNT = 5

export const SpotifyWidgetList: FC<SpotifyWidgetListProps> = ({
  loading,
  error,
  tracks,
}) => {
  if (loading) {
    return (
      <LoadingWrapper>
        <WidgetListLoading />
      </LoadingWrapper>
    )
  }
  if (error) {
    return (
      <Wrapper>
        <WidgetListError error={error} />
      </Wrapper>
    )
  }

  if (!tracks?.length) {
    return null
  }

  return (
    <Wrapper>
      <TrackAudioPlayer
        render={({
          isPlaying,
          loading: innerLoading,
          currentTrackUrl,
          onClick,
        }) => (
          <WrapperList fitContent={tracks.length <= MIN_TRACKS_COUNT}>
            {tracks.map((track) => (
              <SpotifyWidgetListItem
                isPlaying={isPlaying && currentTrackUrl === track.previewUrl}
                loading={innerLoading && currentTrackUrl === track.previewUrl}
                key={track.id}
                {...track}
                onClick={(e) => {
                  e.preventDefault()
                  onClick(e, track.previewUrl)
                  if (!isPlaying) {
                    onPlaySearchedTrack(
                      CampaignTypeEnum.FIRST,
                      null,
                      CampaignPlatformTypeEnum.SPOTIFY,
                    )
                  }
                }}
              />
            ))}
          </WrapperList>
        )}
      />
    </Wrapper>
  )
}
